import React from 'react';
import * as S from './filters.styles';
import InfoIcon from '../../../icons/info';

const displayShowCountries = location => {
  switch (location) {
    case 'visa-on-arrival':
      return <S.Airline>Allow Visa on arrival</S.Airline>;
    case 'e-visa':
      return <S.Airline>Allow E-Visa</S.Airline>;
    case 'visa-free':
      return <S.Airline>Pre-apply</S.Airline>;
  }
};
const AirlineRow = props => {
  const { location, updateFilter, index, isChecked, filterType } = props;

  return (
    <S.PreferredRow>
      <S.LeftCol>
        <S.ChckAirln>
          <S.CheckCustom
            type="checkbox"
            checked={isChecked}
            onChange={() =>
              updateFilter(
                filterType,
                filterType === 'famousFor' || filterType === 'showCountries' ? location : index
              )
            }
          />
          <S.CheckBox>
            <S.TickIco fill="#ffffff" />
          </S.CheckBox>
          <S.AirlineWrap>
            {filterType === 'showCountries' ? (
              displayShowCountries(location)
            ) : (
              <S.Airline>{location}</S.Airline>
            )}
          </S.AirlineWrap>
        </S.ChckAirln>
      </S.LeftCol>
    </S.PreferredRow>
  );
};
export default AirlineRow;
